import { ErrorMessage, Field, Formik, useFormik, Form } from "formik";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CANCEL, HIRE_STATUS, SAVE, TRAINING_DAYS } from "../../../shared/constants/Constants";

const HireStatusForm = ({ hireStatus, submit, cancel }) => {
    const validate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = "Required";
        }
        return errors;
    };

    return (
        <Formik
            initialValues={{
                id: hireStatus?.id ?? null,
                name: hireStatus?.name ?? "",
                training_days: hireStatus?.training_days ?? "",
            }}
            validate={validate}
            onSubmit={submit}
            enableReinitialize
        >
            {() => (
                <Form className="row g-4">
                    <div className="col-md-6">
                        <label htmlFor="name" className="form-label">
                            {HIRE_STATUS}<span className="error-text">*</span>
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="name"
                            placeholder="Enter Employee Status"
                            autoComplete="off"
                        />
                        <span className="error-text">
                            <ErrorMessage name="name" />
                        </span>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="training_days" className="form-label">
                            {TRAINING_DAYS}
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="training_days"
                            placeholder="Enter Training Days"
                            autoComplete="off"
                        />
                        <span className="error-text">
                            <ErrorMessage name="training_days" />
                        </span>
                    </div>
                    <div className="col-md-12">
                        <DefaultButton
                            buttonClass={"btn btn-secondary me-2"}
                            buttonTitle={CANCEL}
                            actionBlock={cancel}
                        />
                        <DefaultButton
                            buttonClass={"default-btn-color"}
                            buttonTitle={SAVE}
                            buttonType={"submit"}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default HireStatusForm;
